/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createDetailFieldHook } from '../../core/factories/createDetailFieldHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetMarketConvictionChartRow } from '../openapi-types.gen.js';
import { type useGetMarketConvictionChartArgs, useGetMarketConvictionChartSpec, useGetMarketConvictionChartRealtime } from '../specs/markets.spec.gen.js';

export type { GetMarketConvictionChartRow } from '../openapi-types.gen.js';
export type { useGetMarketConvictionChartArgs } from '../specs/markets.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): pubkey, interval, from, to, limit.
 */
const _useGetMarketConvictionChart = createHook(useGetMarketConvictionChartSpec, useGetMarketConvictionChartRealtime);
export const useGetMarketConvictionChart = _useGetMarketConvictionChart as (args: useGetMarketConvictionChartArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetMarketConvictionChart>;


/**
 * Per-field subscription hook for the \`useGetMarketConvictionChart\` cache entry.
 * Pass the SAME args as the parent hook (same queryKey → same cache). Returns the named field's value; only the call site
 * re-renders when that field changes (TanStack tracked-properties +
 * per-component `select`).
 *
 *     function Title({ pubkey }) {
 *       const value = useGetMarketConvictionChartField({ pubkey }, 'title');
 *       return <h3>{value}</h3>;
 *     }
 */
export const useGetMarketConvictionChartField = createDetailFieldHook<useGetMarketConvictionChartArgs, GetMarketConvictionChartRow>(useGetMarketConvictionChartSpec);

/**
 * Hover/intent prefetch companion for `useGetMarketConvictionChart`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetMarketConvictionChart();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetMarketConvictionChart = createPrefetchHook(useGetMarketConvictionChartSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetMarketConvictionChartArgs>;
